import { Button, Group, Modal } from "@mantine/core";
import { randomId, useDisclosure } from "@mantine/hooks";
import { IconPhotoUp } from "@tabler/icons-react";
import { useRef, useState } from "react";
import ImageUploader, {
  type ImageUploaderHandle,
} from "src/components/shared/ImageUploader/ImageUploader";
import { useUploadFileApi } from "src/hooks";
import { getYachtId } from "src/utils";
import { Notification } from "src/utils/Notification";

import { useVesselLogo } from "./useVesselLogo";

const dataURLtoFile = (dataurl: string) => {
  const arr = dataurl.split(",");
  const matches = arr[0].match(/:(.*?);/);
  const mime = matches ? matches[1] : "image/png";
  const bstr = atob(arr[arr.length - 1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], randomId(), { type: mime });
};

const ImportVesselLogoButton = () => {
  const [opened, { open, close }] = useDisclosure();
  const { isLoading, refetch } = useVesselLogo();
  const [image, setImage] = useState("");
  const { upload, isUploading } = useUploadFileApi();
  const uploaderRef = useRef<ImageUploaderHandle>(null);

  const handleClose = () => {
    close();
    setImage("");
  };

  const handleSubmit = async () => {
    if (!image) {
      Notification("Error", "Please upload a logo image", "red");
      return;
    }

    await upload(
      "save-vessel-logo",
      [dataURLtoFile(image)],
      { yachtid: getYachtId() },
      () => {
        Notification("Success", "Vessel logo saved successfully", "green");
        refetch();
        handleClose();
      },
      true,
    );
  };

  return (
    <>
      <Button
        type="button"
        variant="outline"
        leftSection={<IconPhotoUp size={16} />}
        onClick={() => uploaderRef.current?.openFilePicker()}>
        Upload Logo
      </Button>

      <div style={{ display: "none" }}>
        <ImageUploader
          ref={uploaderRef}
          image={image}
          setImage={setImage}
          onImageReady={open}
          isStamp
          label="Logo"
        />
      </div>

      <Modal opened={opened} onClose={handleClose} title="Vessel Logo" size="md">
        {image && (
          <img
            src={image}
            alt="Vessel logo"
            style={{ maxWidth: "100%", display: "block", margin: "0 auto" }}
          />
        )}
        <Group justify="right" mt={15}>
          <Button
            onClick={handleSubmit}
            loading={isUploading || isLoading}
            disabled={!image}>
            Save Logo
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default ImportVesselLogoButton;
